import { IBaseResponse } from "@/base/rpc/rpc-types";

export enum ContentFormatType {
    PlainText = 0,
    Markdown = 1,
    HTML = 2,
};

export enum DocumentNodeType {
    PureContent = 0,
    Folder = 1,
    FolderWithContent = 2,
}

export enum DocumentStatus {
    Normal = 0,
}

export interface IDocumentOutline {
    ID: number;
    Path: string;
    Key: string;
    Title: string;
    ContentFormat: ContentFormatType;
    ParentId: number;
    Order: number;
    AuthLevel: number;
    BookId: number;
    Status: DocumentStatus | number;
    NodeType: DocumentNodeType;
    Author: string;
    CommitTime: string;
    Creator: string;
    CreateTime: string;
    UpdateTime: {
        Time: string,
        Valid: boolean;
    };
}

export interface IDocument extends IDocumentOutline {
    Content: string;
}

export type IDocumentsResponse = IBaseResponse<Array<IDocumentOutline>>;

export type IDocumentResponse = IBaseResponse<IDocument>;
